export default __webpack_public_path__ + "static/media/Saksham .5c31ade1.jpeg";